<section>
  <div class="menu">
    <i class="pi pi-bars" style="font-size: 2rem" (click)="onChangeMenu.emit()"></i>
    <img src="/assets/media/images/logo/Rendafin.png" alt="">
   </div>
  <div class="actions">
    <!-- TODO(pipelines): campana de notificaciones OCULTA hasta el módulo de Pipelines.
         Las notificaciones del funnel aún no se mapean del todo; se termina en Pipelines.
         Reactivar junto con el ítem "Bandeja de funnel" del menú (menu.constant.ts). -->
    <!-- <app-notification-bell *appIfHasPermission="['activities', 'view']"></app-notification-bell> -->
    <div #avatarmenu class="avatar" [style]="'background-image: url('+avatar+')'"></div>
    <div class="info">
      <h5>{{authService.getUser?.user?.names?.firstName ?? ''}} {{authService.getUser?.user?.names?.lastName ?? ''}}</h5>
      <h6 style="color: #84898e">{{authService.getUser?.user?.email ?? ''}}</h6>
      <span [ngClass]="getRoleClass()">
        {{ role }}
      </span>
    </div>
    <p-contextMenu [target]="avatarmenu" [model]="items" [triggerEvent]="'click'"></p-contextMenu>
  </div>
</section>
<!-- Feedback del comando "Copiar link de referidos" (y futuras acciones del menú). -->
<p-toast position="top-right"></p-toast>
